module.exports = __webpack_public_path__ + "static/img/errPic.91910e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/errPic.jpg
// module id = KzRS
// module chunks = 3